<template>
  <li class="+mg-bottom +pd-bottom +border-bottom +border-gray-light">
    <article
      class="horizontal-card media --reverse +mg-bottom-none +cursor-pointer"
      data-faux-anchor="true"
    >
      <div class="media__figure" v-if="article.feature_image">
        <div
          class="horizontal-card__image-container hub-page__desktop-articles-image"
          v-if="isDesktop"
        >
          <img
            :data-src="article.feature_image.source_url + fastlyParams"
            :alt="article.feature_image.alt_text"
            class="horizontal-card__image lazyload lazyload--fade"
          />
        </div>
      </div>
      <div class="horizontal-card__body media__body">
        <div>
          <h3 class="heading-secondary +heading-epsilon +mg-bottom-sm">
            <a
              :href="article.canonical_url"
              data-linktype="recirculation"
              data-navheading="Latest Articles"
              >{{ article.title }}</a
            >
          </h3>
          <p class="+font-calibre-regular">{{ article.description }}</p>
        </div>
        <span class="subheading --regular">{{ articleDate }}</span>
      </div>
    </article>
  </li>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  props: {
    article: { type: Object, required: true },
    fastlyParams: { type: String, required: true }
  },
  computed: {
    ...mapGetters(['isDesktop']),
    articleDate() {
      return moment(this.article.date).format('MMM Do, YYYY')
    }
  }
}
</script>
